import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('bulk_benefits_set', '/bulk_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
